import clsx from 'clsx';
import { type MouseEvent } from 'react';
import { Icon } from '@recargas-dominicanas/core/components';
import { style } from './status.module.css';

interface Props {
  icon: string;
  title: string;
  rotatedIcon?: boolean;
  severity?: 'info' | 'error';
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
}

export function Status(props: Props) {

  const {
    icon,
    title,
    severity = 'info',
    rotatedIcon,
    onClick
  } = props;

  return (
    <div
      onClick={onClick}
      className={clsx(
        style.container, 
        onClick && style.clickable,
        onClick && severity === 'error' && style.clickableError
      )}>
      <Icon 
        className={clsx(
          style.icon, 
          rotatedIcon && style.rotateAnimation,
          severity === 'error' && style.error
        )}
        icon={icon}/>
      <span 
        className={clsx(
          style.title,
          severity === 'error' && style.error
        )}>
        {title}
      </span>
    </div>
  );
}
